import NotFound from '@/components/svgs/kd/stub';

const StubKD = ({
  withIcon = true,
  texts,
}: {
  withIcon?: boolean;
  texts: { mainText: string; subText?: string };
}) => {
  return (
    <div className="flex flex-col items-center mx-auto max-w-150 my-20">
      {withIcon && <NotFound aria-hidden="true" className="w-28 h-28 shrink-0" />}
      <p className="mt-8 max-md:text-2xl md:text-4xl font-bold text-kd-woodsmoke text-center">
        {texts.mainText}
      </p>
      {texts.subText && <p className="mt-2 text-center text-kd-mako">{texts.subText}</p>}
    </div>
  );
};

export default StubKD;
